import { createAction } from 'redux-actions';
import { REMOVE_THREAD_MESAGE_FROM_HISTORY } from '../constants/actionTypes';
export const removeThreadMessageFromHistory = createAction(REMOVE_THREAD_MESAGE_FROM_HISTORY, ({
  messageId,
  threadId
}) => ({
  messageId,
  threadId
}));